import React, { useEffect, useState } from "react";
import { SearchOutlined, CloseCircleFilled } from "@ant-design/icons";

/**
 * شريط أدوات الجدول: حقل بحث منسّق + أزرار الإجراءات (إضافة / تصدير...).
 *
 * يحتفظ بنص البحث في حالة داخلية ويؤخّر إرساله للأب (debounce) حتى لا يُطلق
 * طلباً للخادم مع كل حرف. الأب يستقبل القيمة النهائية عبر onSearch فقط.
 */
const TableToolbar = ({
  value = "",
  onSearch,
  placeholder = "بحث...",
  delay = 400,
  actions = null,
  showSearch = true,
}) => {
  const [term, setTerm] = useState(value);

  useEffect(() => {
    if (term === value) return undefined;

    const timer = setTimeout(() => onSearch(term), delay);

    return () => clearTimeout(timer);
    // نتعمّد الاعتماد على term فقط: إضافة onSearch/value تعيد تشغيل المؤقّت
    // مع كل إعادة رسم للأب فينكسر التأخير (debounce).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term, delay]);

  const submitNow = () => onSearch(term);

  return (
    <div className="table-toolbar">
      {showSearch && (
      <div className="table-toolbar__search">
        <SearchOutlined className="table-toolbar__search-icon" />
        <input
          type="text"
          value={term}
          placeholder={placeholder}
          aria-label={placeholder}
          onChange={(e) => setTerm(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submitNow()}
        />
        {term && (
          <button
            type="button"
            className="table-toolbar__clear"
            aria-label="مسح البحث"
            onClick={() => setTerm("")}
          >
            <CloseCircleFilled />
          </button>
        )}
      </div>
      )}

      {actions && <div className="table-toolbar__actions">{actions}</div>}
    </div>
  );
};

export default TableToolbar;
